<div class="modal__header"> 
	<h2 class="title" id="modal__title">
		{{ 'shoppingBasket.text.modalHeader' | ibeadmin | async }}
	</h2>
	<div class="modal__header-actions">
		<button aria-label="Close dialog" (click)="INDRA_cyberSourceReject()">
			<app-svg svg="icons.svg#general--close"></app-svg>
		</button>
	</div>
</div>

<div class="modal__body sl--scrollable">
	<ng-container *ngIf="msgOne">
		<p> {{ 'shoppingBasket.text.messageMSG1Paragraph' | ibeadmin | async }} </p>
	</ng-container>
	<ng-container *ngIf="msgTwo">
		<p> {{ 'shoppingBasket.text.messageMSG2Paragraph' | ibeadmin | async }} </p>
	</ng-container>
	<br/>
	<p class="attention-text">
		<span class="attention-text-red">
		{{ 'shoppingBasket.text.attention' | ibeadmin | async }}:
		</span>
		{{ 'shoppingBasket.text.attentionStatement' | ibeadmin | async }}
	</p>
	<!--
	<p> {{ 'shoppingBasket.text.validationSupportingParagraph1' | ibeadmin | async }} </p>
	<p> {{ 'shoppingBasket.text.validationSupportingParagraph2' | ibeadmin | async }} </p>
	-->
</div>

<div class="modal__footer">
	<div class="modal__footer-action positive-action">
		<button class="button button-accent button--fat" (click)="INDRA_cyberSourceAccept()" [disabled]="!acceptButtonEnabled ? 'disabled': null">
			{{'shoppingBasket.button.acceptValidate' | ibeadmin | async }}
		</button>
	</div>
	<div class="modal__footer-action negative-action">
		<button class="button button--fat" (click)="INDRA_cyberSourceReject()">
			{{ 'shoppingBasket.button.declineValidate' | ibeadmin | async }}
		</button>
	</div>
</div>

